/**
 * @module constants/musicSubgenres
 * @description
 *   Client-side optional subgenre tree for UploadForm.
 *   Keep aligned with server/utils/musicGenres.js — parity asserted by
 *   server/__tests__/utils/genreCatalogParity.test.js (no CRA↔server runtime import).
 */

/** Optional subgenres by parent — ids + labels for the upload select. */
export const MUSIC_SUBGENRES_BY_PARENT = {
  pop: [
    { id: 'dance_pop', label: 'Dance Pop' },
    { id: 'bedroom_pop', label: 'Bedroom Pop' },
    { id: 'hyperpop', label: 'Hyperpop' },
    { id: 'synth_pop', label: 'Synth Pop' },
  ],
  hip_hop: [
    { id: 'trap', label: 'Trap' },
    { id: 'drill', label: 'Drill' },
    { id: 'boom_bap', label: 'Boom Bap' },
    { id: 'phonk', label: 'Phonk' },
    { id: 'melodic_rap', label: 'Melodic Rap' },
  ],
  electronic: [
    { id: 'house', label: 'House' },
    { id: 'techno', label: 'Techno' },
    { id: 'bass_dubstep', label: 'Bass / Dubstep' },
    { id: 'drum_and_bass', label: 'Drum & Bass' },
    { id: 'trance', label: 'Trance' },
  ],
  'r&b': [
    { id: 'neo_soul', label: 'Neo-Soul' },
    { id: 'alt_rnb', label: 'Alt R&B' },
    { id: 'contemporary_rnb', label: 'Contemporary R&B' },
  ],
  rock: [
    { id: 'indie_rock', label: 'Indie Rock' },
    { id: 'punk', label: 'Punk' },
    { id: 'classic_rock', label: 'Classic Rock' },
    { id: 'metal', label: 'Metal' },
    { id: 'alternative', label: 'Alternative' },
  ],
  country: [
    { id: 'americana', label: 'Americana' },
    { id: 'country_pop', label: 'Country Pop' },
    { id: 'contemporary_country', label: 'Contemporary Country' },
    { id: 'country_rock', label: 'Country Rock' },
  ],
  instrumental: [
    { id: 'ambient', label: 'Ambient' },
    { id: 'cinematic', label: 'Cinematic' },
    { id: 'classical', label: 'Classical' },
    { id: 'lofi_instrumental', label: 'Lo-fi Instrumental' },
    { id: 'jazz_instrumental', label: 'Jazz Instrumental' },
  ],
  latin: [
    { id: 'reggaeton', label: 'Reggaeton' },
    { id: 'latin_pop', label: 'Latin Pop' },
    { id: 'latin_trap', label: 'Latin Trap' },
    { id: 'regional_mexicano', label: 'Regional Mexicano' },
  ],
  afrobeats: [{ id: 'amapiano', label: 'Amapiano' }],
  k_pop: [],
  indie: [
    { id: 'indie_pop', label: 'Indie Pop' },
    { id: 'indie_folk', label: 'Indie Folk' },
  ],
};
